import {
  instanceOfProfilingWizardChecklistItemId,
  type ProfilingWizardChecklistItem,
} from 'pco-product-service-internal-consumer';

export const WizardPostMessages = {
  PCO_WIZARD_STATUS: 'pco-product-service:wizardStatus',
  PCO_WIZARD_STATUS_REQUEST: 'pco-product-service:wizardStatusRequest',
} as const;

export type WizardPostMessageLiterals = (typeof WizardPostMessages)[keyof typeof WizardPostMessages];

export type WizardStatusPayload =
  | {
      hasError: false;
      isComplete: boolean;
      checklist?: ProfilingWizardChecklistItem[];
      userId?: string;
    }
  | { hasError: true; userId?: string };

export type WizardPostMessage = {
  message: WizardPostMessageLiterals;
  value?: unknown;
};

export const isWizardStatusPayload = (value: unknown): value is WizardStatusPayload => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const payload = value as Record<string, unknown>;

  if (payload.hasError === true) {
    return true;
  }

  return (
    payload.hasError === false &&
    typeof payload.isComplete === 'boolean' &&
    (payload.checklist === undefined ||
      (Array.isArray(payload.checklist) && payload.checklist.every(isWizardChecklistItem)))
  );
};

const isWizardChecklistItem = (value: unknown): value is ProfilingWizardChecklistItem => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const item = value as Record<string, unknown>;

  return instanceOfProfilingWizardChecklistItemId(item.id) && typeof item.completed === 'boolean';
};
